<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <banner :bgImage="bgImage"></banner>
    <section class="clientVoice">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/clientConceptPic4.jpg" />
          </div>
          <div class="solutionConceptBoxL clientCaseBlue">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">用心聆听客户的声音</div>
              <div class="solutionConceptInConn">
                睿哲科技采用下一代互联网技术对我们教育网进行IPv6全面升级改造，解决用户对教育资源日益增长的需求与现有网络信息资源供给不足的矛盾，推动P2P教学模式和个性化教学模式的有效实施，为教育网络系统可持续发展扫清障碍。
                <p>——某市教育局</p>
              </div>
            </div>
            <div class="clientCaseArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="clientIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          注重客户收益，想客户之所想
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon05.png" />
            <div class="solutionIncomeConn">
              提升和保障校园网络<br />及应用信息安全的等级
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon06.png" />
            <div class="solutionIncomeConn">
              快速实现平行校园<br />内部教学资源的充分共享
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon07.png" />
            <div class="solutionIncomeConn">
              打通教育管理机构与<br />各校园之间的数据交换
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="clientChallenge">
      <div class="clientChallengeBox">
        <img src="../../../static/images/clientChallengeBg1.jpg" />
        <div class="clientChallengeConn">
          <div class="clientChallengeTit">直面挑战，毫不畏惧</div>
          <ul class="clientChallengeList">
            <li class="shortBox" style="padding-bottom: 42px">
              <div class="clientChallengeBoldTit">
                实现各中小学网站及应用IPv6升级
              </div>
              <div class="clientChallengeMsg">
                全市有648所中小学，网络、终端设备以及教育软件均不支持IPv6，需要重新整合与研发基于IPv6的教育支撑和管理软件
              </div>
            </li>
            <li class="shortBox">
              <div class="clientChallengeBoldTit">
                实现各中小校园之间的数据共享
              </div>
              <div class="clientChallengeMsg">
                该市各中小学的教育资源没有统一整合，无法实现数据共享及调用
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="clientSolution">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          成熟的解决方案，难题迎刃而解
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <div class="clientSolutionTit">终端设备</div>
            <div class="clientSolutionConn">
              对全市中小学的网络和终端设备及软件进行IPv6的升级改造
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">云数据中心</div>
            <div class="clientSolutionConn">
              改造中心机房，对教育云数据中心和网络管理中心的设备、支撑和管理软件进行IPv6的升级改造
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">教育网站</div>
            <div class="clientSolutionConn">
              对教育应用平台、网站进行IPv6的升级改造，整合与研发基于IPv6的教育软件和网络资源
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage: "../../../static/images/clientDetailBanner.jpg?0219",
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./case";
.solutionCase {
}
</style>



// WEBPACK FOOTER //
// src/pages/case/caseDetail4.vue